import React from "react";
import { ArrowRight } from "lucide-react";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { Box } from "@mui/material";
import { heroArrowAnimation } from "../index.js";

const HeroActions = ({ history }) => {
  return (
    <Box
      className="home-hero-actions"
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <CommonButton
        variant="contained"
        size="hero"
        onClick={() => (window.location.href = "#game-arena")}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          ...heroArrowAnimation,
        }}
      >
        Play Now
        <Box
          component="span"
          className="hero-arrow"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible",
            width: "18px",
            height: "18px",
            flexShrink: 0,
            color: (theme) => theme.palette.primary.contrastText,
          }}
        >
          <ArrowRight
            size={18}
            strokeWidth={2.5}
          />
        </Box>
      </CommonButton>

      <CommonButton
        variant="outlined"
        size="hero"
        onClick={() => history.push("/all-lotteries")}
        sx={{
          color: (theme) => theme.custom.colors.alpha.black[85],
          borderColor: (theme) => theme.custom.colors.alpha.black[30],
          "&:hover": {
            backgroundColor: (theme) => theme.custom.colors.alpha.black[10],
            borderColor: (theme) => theme.custom.colors.alpha.black[60],
          },
        }}
      >
        Browse all games
      </CommonButton>
    </Box>
  );
};

export default HeroActions;